import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";
import {TemplateRef} from "@angular/core";

export enum JobsTableColumn {
  JobId = 'job_id',
  JobNumber = 'job_number',
  JobType = 'job_type',
  JobStatus = 'job_status',
  Assets = 'asset',
  Location = 'location',
  DueDate = 'due_date',
  QuoteNumber = 'quote_number',
  PickTicketNumber = 'pick_ticket_number',
  RenewPickTicketNumber = 'renew_pick_ticket_number',
  CrNumber = 'cr_number',
  OrderNumber = 'order_number',
  ReturnTrackingNumber = 'return_tracking_number'
}

export function constructJobsColumns(
  jobNumberColumnTmp: TemplateRef<any>,
  assetColumnTmp: TemplateRef<any>,
  showQuoteNumber: boolean,
  showCustomFields: boolean
): TableColumn[] {
  let columns: TableColumn[] = [
    {
      columnId: JobsTableColumn.JobNumber,
      header: 'Job Number',
      type: TableColumnType.Template,
      template: jobNumberColumnTmp,
      sortable: true
    },
    {
      columnId: JobsTableColumn.JobType,
      header: 'Job Type',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: JobsTableColumn.JobStatus,
      header: 'Status',
      type: TableColumnType.Tag,
      sortable: true
    },
    {
      columnId: JobsTableColumn.Assets,
      header: 'Asset(s)',
      type: TableColumnType.Template,
      template: assetColumnTmp,
      sortable: true
    },
    {
      columnId: JobsTableColumn.Location,
      header: 'Location',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: JobsTableColumn.DueDate,
      header: 'Job Due Date',
      type: TableColumnType.Text,
      sortable: false
    },
    {
      columnId: JobsTableColumn.QuoteNumber,
      header: 'Quote Number',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: JobsTableColumn.PickTicketNumber,
      header: 'Pick Tick. No.',
      type: TableColumnType.Text,
      sortable: false
    },
    {
      columnId: JobsTableColumn.RenewPickTicketNumber,
      header: 'Renew Pick Ticket No.',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: JobsTableColumn.CrNumber,
      header: 'CR No.',
      type: TableColumnType.Text,
      sortable: false
    },
    {
      columnId: JobsTableColumn.OrderNumber,
      header: 'Order No.',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: JobsTableColumn.ReturnTrackingNumber,
      header: 'Return Tracking No.',
      type: TableColumnType.Text,
      sortable: true
    }
  ];

  if (!showQuoteNumber) {
    columns = columns.filter(col => col.columnId !== JobsTableColumn.QuoteNumber);
  }
  if (!showCustomFields) {
    columns = columns.filter(col => col.columnId !== JobsTableColumn.PickTicketNumber
      && col.columnId !== JobsTableColumn.CrNumber);
  }
  return columns;
}
